import './App.css';
import PetrosMain from "./components/petrosMain"
import { DataProvider } from './dataContext';

function App() {
  return (
    <DataProvider>
        <PetrosMain />
    </DataProvider>
  )
}

export default App;